import { render, staticRenderFns } from "./create-voucher.vue?vue&type=template&id=088b65f7"
import script from "./create-voucher.vue?vue&type=script&lang=js"
export * from "./create-voucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports